<template>
  <div class="mt-4">
    <div class="login-logo">
      <img src="/resources/logos/BS LOGO_LOGO PLATEADO.png" alt style="width:190px" />
    </div>
    <div class="login-box-body">
      <p class="login-box-msg">Sign-In to Your Account</p>
      <form
        action="../../index.html"
        method="post"
        class="form-element"
        @submit="onSubmit"
      >
        <div class="form-group has-feedback">
          <input
            type="text"
            class="form-control"
            placeholder="Username"
            v-model="model.username"
          />
          <span class="ion ion-email form-control-feedback"></span>
        </div>
        <div class="form-group has-feedback">
          <input
            type="password"
            class="form-control"
            placeholder="Password"
            v-model="model.password"
          />
          <span class="ion ion-locked form-control-feedback"></span>
        </div>
        <div class="row">
          <div class="col-6">
            <div class="checkbox">
              <input type="checkbox" id="basic_checkbox_1" />
              <label for="basic_checkbox_1">Remember Me</label>
            </div>
          </div>

          <div class="col-6">
            <div class="fog-pwd">
              <router-link to="/recovery" class="text-white">
                <i class="ion ion-locked"></i> Forgot password?
              </router-link>
              <br />
            </div>
          </div>

          <div class="col-12 text-center">
            <button
              v-if="!loading"
              type="submit"
              class="btn btn-success btn-block margin-top-10"
            >
              SIGN IN
            </button>
            <button
              v-else
              type="submit"
              class="btn btn-success btn-block margin-top-10"
              disabled
            >
              Loading
              <i class="fa fa-circle-o-notch fa-spin"></i>
            </button>
          </div>
        </div>
      </form>

      <div class="margin-top-30 text-center">
        <p>
          Don't have an account?
          <router-link to="/register" class="m-l-5 text-yellow hover-warning"
            >Sign Up</router-link
          >
        </p>
      </div>
    </div>
  </div>
</template>

<style>
.login-box,
.register-box,
.lockscreen-wrapper {
  height: 70%;
  margin: auto;
  float: unset !important;
  padding-top: 5em;
  border-radius: 7px;
  padding: unset !important;
}
</style>

<script>
import router from "@/router";

export default {
  name: "login",
  data() {
    return {
      loading: false,
      model: {
        username: "",
        password: ""
      }
    };
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.loading = true;
      this.$http
        .post("/api/v1/client/sessions", this.model)
        .then((response) => {
          this.$store.commit("setCurrentUser", response.data.user);
          this.$store.commit("setAuthToken", response.data.auth_token);
          this.storeLogin(response.data);
          this.loading = false;
        })
        .catch((error) => {
          this.$toasted.show(error.response.data.error, {
            position: "top-right",
            duration: 5000,
            type: "error",
            closeOnSwipe: true
          });
          this.loading = false;
        });
    },
    storeLogin(data) {
      let action;
      let firstPage = "dashboard?auth=true";
      if (data.user.temp_user) firstPage = "plans";
      action = async () => {
        // await localStorage.setItem("auth_token", data.auth_token);
        // await localStorage.setItem("user", JSON.stringify(data.user));
        await router.push(firstPage);
      };
      action();
    }
  }
};
</script>
